import APIUtils from '@spothero/utils/api';

const include =
    'default_image,has_upcoming_events,google_places,deep_links,serp,parent_url,meta_title,monthly_meta_title,meta_description,monthly_meta_description,destination,monthly_description,monthly_relative_url,monthly_short_description,desktop_zoom_level,mobile_zoom_level,monthly_desktop_zoom_level,monthly_mobile_zoom_level,default_map_zoom_level,airport,hide_event_modal';

const DestinationAPI = {
    get(id) {
        return APIUtils.get(`destinations/${id}/`, {include});
    },

    getBySlug(city, destination) {
        return APIUtils.get(`cities/${city}/destinations/${destination}/`, {
            include,
        });
    },

    getAllInCityByCategorySlug({city, category}) {
        return APIUtils.get(
            `cities/${city}/categories/${category}/destinations/`,
            {include}
        );
    },
};

export default DestinationAPI;
